import { motion } from 'framer-motion';
import SkillBar from '../../../components/base/SkillBar';

const skills = [
  { name: 'Adobe Photoshop', percentage: 90 },
  { name: 'Adobe Illustrator', percentage: 88 },
  { name: 'Adobe InDesign', percentage: 80 },
  { name: 'Figma', percentage: 85 },
  { name: 'Canva Pro', percentage: 92 },
  { name: 'Typography & Color Theory', percentage: 90 },
];

export default function LuxurySkillsSection() {
  return (
    <section className="relative py-24 bg-gradient-to-b from-charcoal to-deepBlue overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">
            Tools & <span className="gradient-text">Expertise</span>
          </h2>
          <p className="text-white/70 text-lg font-body max-w-2xl mx-auto">
            Mastery of industry-leading design tools and techniques
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto">
          <div className="glass-panel p-10 rounded-2xl glow-gold">
            <div className="space-y-8">
              {skills.map((skill, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.9, delay: index * 0.1 }}
                >
                  <SkillBar name={skill.name} percentage={skill.percentage} />
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
